import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { QuestionnaireService } from "../services/questionnaire.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss']
})
export class TermsOfUseComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal,
    private questionnaireService: QuestionnaireService,
    private translate: TranslateService) { }
  isAdvisor = this.questionnaireService.getIsAdvisor();
  @Input() agreeEmail: FormControl = new FormControl();
  errorMessageOnComponent;
  isDisplayed = false;
  currentStep: any;
  ngOnInit() {
    if (this.questionnaireService.openTermsOfUse === true) {
      this.activeModal.close();
    }
  }

  continue() {
    //if(this.agreeEmail.value === true){
    this.activeModal.close({ agreeEmail: this.agreeEmail.value })
    this.isDisplayed = false;
    this.currentStep = this.questionnaireService.getStep("user-details");
    let termOfUse = { text: this.translate.instant('TERMS_OF_USE.AGREE'), type: 'termOfUse' }
    this.questionnaireService.sendGA(this.currentStep, '7', termOfUse);
    //}
    //else{
    // this.errorMessageOnComponent = [{ text: this.translate.instant('TERMS_OF_USE.ERROR') }];
    //  this.isDisplayed = true;
    //}
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent): any {
    if (event.key === 'Enter') {
      if ((event.target as HTMLElement).dataset.id === 'check-agree-mail') {
        let checkbox2b = (document.getElementById('checkbox-2b') as HTMLInputElement);
        if (checkbox2b.checked) {
          checkbox2b.checked = false;
          this.agreeEmail.setValue('');
        } else {
          checkbox2b.checked = true;
          this.agreeEmail.setValue('on');
        }
      }
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/terms-of-use/terms-of-use.component.ts